import { render, staticRenderFns } from "./ShareVideoList.vue?vue&type=template&id=9388bafa&scoped=true&"
import script from "./ShareVideoList.vue?vue&type=script&lang=js&"
export * from "./ShareVideoList.vue?vue&type=script&lang=js&"
import style0 from "./ShareVideoList.vue?vue&type=style&index=0&id=9388bafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9388bafa",
  null
  
)

export default component.exports